import React from "react";
import ListD from "./Components/List";
import { Grid, Paper, withStyles } from "@material-ui/core";
import EmailTemplateFragment from "./Components/Fragment";
import axios from "axios";
import { authCheckState } from "../../../store/actions/auth";
import { compose } from "redux";
import { connect } from "react-redux";

const useStyles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
});

class EmailTemplate extends React.Component {
  state = {
    currentFragment: "Approval",
    currentFragmentData: {
      template_name: "Approval",
      mail_subject: "This is the mail_subject",
      mail_text: "This is the body mail_text",
    },
    fragmentsData: [
      {
        template_name: "Approval",
        slug: "approval",
        mail_subject: "Approval mail_subject",
        mail_text: "This is the body mail_text",
      },
      {
        slug: "certificate",
        template_name: "Certificate",
        mail_subject: "Certificate mail_subject",
        mail_text: "This is the body mail_text",
      },
      {
        slug: "general",
        template_name: "General",
        mail_subject: "General mail_subject",
        mail_text: "This is the body mail_text",
      },
    ],
    isErrorDialogPopUp: true,
    ErrorMessage: "",
  };

  componentDidMount() {
    this.props.authCheckState();
    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${this.props.token}`,
    };
    this.setState({ loading: true });
    axios
      .get(window.location.origin + `/api/v1/email_template/`)
      .then((resp) => {
        if (typeof resp.data === "object" && resp.data.length === 0) {
          this.state.fragmentsData.forEach((each) => {
            this.createFragment(each);
          });
          this.loadData();
        }
        if (typeof resp.data === "object" && resp.data.length) {
          this.setState({
            fragmentsData: resp.data,
          });
          this.changeFragment(this.state.currentFragment);
        }
      })
      .catch((err) => {
        this.setState({
          isErrorDialogPopUp: true,
          ErrorMessage: "Failed to load trainings",
        });
      });
  }
  loadData = () => {
    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${this.props.token}`,
    };
    this.setState({ loading: true });
    axios
      .get(window.location.origin + `/api/v1/email_template/`)
      .then((resp) => {
        if (typeof resp.data === "object" && resp.data.length === 0) {
        }
        if (typeof resp.data === "object" && resp.data.length) {
          this.setState({
            fragmentsData: resp.data,
          });
          this.changeFragment(this.state.currentFragment);
        }
      })
      .catch((err) => {
        this.setState({
          isErrorDialogPopUp: true,
          ErrorMessage: "Failed to load trainings",
        });
      });
  };
  createFragment = (data) => {
    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${this.props.token}`,
    };
    this.setState({ loading: true });
    axios
      .post(window.location.origin + `/api/v1/email_template/`, data)
      .then((resp) => {
        if (typeof resp.data === "object" && resp.data.length) {
          this.setState({
            isEditing: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          isErrorDialogPopUp: true,
          ErrorMessage: "Failed to load trainings",
        });
      });
  };

  changeFragment = (fragment = "Approval") => {
    let currentFragmentData = this.state.fragmentsData.filter(
      (item) => item.template_name === fragment
    );
    currentFragmentData = currentFragmentData.length
      ? currentFragmentData.pop()
      : this.state.currentFragmentData;
    this.setState({
      currentFragment: fragment,
      currentFragmentData,
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <div className={classes.root}>
          <Grid container>
            <Grid item xs={2}>
              <Paper className={classes.paper}>
                <ListD
                  currentFragment={this.state.currentFragment}
                  changeFragment={this.changeFragment}
                />
              </Paper>
            </Grid>
            <Grid item xs={10}>
              <Paper className={classes.paper}>
                <EmailTemplateFragment
                  permissions={this.props.permissions}
                  authCheckState={this.props.authCheckState}
                  token={this.props.token}
                  loadData={this.loadData}
                  currentFragment={this.state.currentFragment}
                  fragmentsData={this.state.currentFragmentData}
                />
              </Paper>
            </Grid>
          </Grid>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    error: state.book.error,
    isAuthenticated: state.auth.token !== null,
    successAuth: state.auth.successAuth,
    permissions:
      typeof state.auth.user["permissions"] != "undefined"
        ? state.auth.user.permissions
        : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authCheckState: () => dispatch(authCheckState()),
  };
};
export default compose(
  withStyles(useStyles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps)
)(EmailTemplate);
